module.exports = __webpack_public_path__ + "static/img/erweima.ebf90b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/erweima.png
// module id = Nbjv
// module chunks = 1